<template>
  <transition name="fade">
    <div
      v-if="isVisible"
      class="blanket"
      :class="{ 'is-fixed': fixed }"
      :style="{ opacity }"
      @click="$emit('click', $event)"
    >
      <slot></slot>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Blanket',
  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },

    /**
     * Controls whether the blanket should use fixed or absolute positioning
     * Use fixed for page-level overlays, absolute for contained elements
     */
    fixed: {
      type: Boolean,
      default: true,
    },
    opacity: {
      type: Number,
    },
  },

  emits: ['click'],
});
</script>

<style scoped>
.blanket {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #6d6a72;
  z-index: 1000;
}

.is-fixed {
  position: fixed;
}

/* Fade transition */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
